import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    recaptchaVerified: localStorage.getItem("recaptcha_verified") === "true",
    loadingModal: false,
    errorPopup: false,
    errorPopupProps: {
      title: "Σφάλμα!",
      text: "error",
      color: "indianRed",
      class: "white--text indianRed text-center justify-center",
      icon: "error",
      successStyle: false,
    },
    yearsInfo: {},
    filesBaseUrl: "",
    filesThumbnailBaseUrl: "",
    bookInfoDialog: false,
    selectedBook: null,
    institutions: [],
    academicSecretariats: [],
    institutionAcademics: [],
  },
  getters: {
    recaptchaVerified: (state) => state.recaptchaVerified,
    loadingModal: (state) => state.loadingModal,
    errorPopup: (state) => state.errorPopup,
    errorPopupProps: (state) => state.errorPopupProps,
    yearsInfo: (state) => state.yearsInfo,
    filesBaseUrl: (state) => state.filesBaseUrl,
    filesThumbnailBaseUrl: (state) => state.filesThumbnailBaseUrl,
    bookInfoDialog: (state) => state.bookInfoDialog,
    selectedBook: (state) => state.selectedBook,
    institutions: (state) => state.institutions,
    academicSecretariats: (state) => state.academicSecretariats,
    institutionAcademics: (state) => state.institutionAcademics,
  },
  mutations: {
    setRecaptchaVerified: function (state, data) {
      state.recaptchaVerified = data;
    },
    setLoadingModal: function (state, data) {
      state.loadingModal = data;
    },
    setErrorPopup: function (state, data) {
      state.errorPopup = data;
    },
    setErrorPopupProps: function (state, data) {
      state.errorPopupProps = data;
    },
    setBookInfoDialog: function (state, data) {
      state.bookInfoDialog = data;
    },
    setSelectedBook: function (state, data) {
      state.selectedBook = data;
    },
    setFilesBaseUrl: function (state, data) {
      state.filesBaseUrl = data;
    },
    setFilesThumbnailBaseUrl: function (state, data) {
      state.filesThumbnailBaseUrl = data;
    },
    setYearsInfo: function (state, data) {
      state.yearsInfo = data;
    },
    setInstitutions: function (state, data) {
      state.institutions = data;
    },
    setAcademicSecretariats: function (state, data) {
      state.academicSecretariats = data;
    },
    setInstitutionAcademics: function (state, data) {
      state.institutionAcademics = data;
    },
  },
});
